module.exports = "/_next/static/images/easycover-1bbee0308a32240905d2d738be0dabd4.svg";